import _regeneratorRuntime from "/data/shupian/qds-scrmnet-0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/data/shupian/qds-scrmnet-0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/data/shupian/qds-scrmnet-0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/data/shupian/qds-scrmnet-0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import { constantRouterMap } from './router.config.js';
import h5Router from './h5-router';
import { customerRouter } from './customer-group-router';
import { noticeRouter } from './pcDialog';
import { sidebarRouter } from './sidebar';
import CorpUserCardRouter from './CorpUserCardRouter';
import { channelAdmin } from './channelAdmin.js'; //渠道相关的
import customerLibraryRouter from './customer-library.js'; //客户资料库（自 crisps-production-mobile-h5 迁移）

var originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};
Vue.use(Router);
var createRouter = function createRouter() {
  return new Router({
    mode: 'hash',
    // 浏览器前进/后退（如详情页 back 返回列表）恢复原滚动位置，配合 keep-alive 保留的数据一起还原现场；
    // 正常 push 进新页面仍回顶部
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
      return savedPosition || {
        y: 0
      };
    },
    routes: [].concat(_toConsumableArray(constantRouterMap), _toConsumableArray(customerRouter), _toConsumableArray(h5Router), _toConsumableArray(noticeRouter), _toConsumableArray(CorpUserCardRouter), _toConsumableArray(sidebarRouter), _toConsumableArray(channelAdmin), _toConsumableArray(customerLibraryRouter))
  });
};
var router = createRouter();
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher;
}
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var isInitialNav, isClPath, isClIndex, query;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // 客户资料库内页不可作为「硬加载入口」：浏览器刷新/外部重新打开（PC 侧边栏、企微等带 customerId
          // 的 URL）落在内页 hash（列表/详情/官文/公司详情）时，强制重定向回模块首页重新加载——
          // 内页位置只是 SPA 内导航的停留结果，不作为入口（用户要求：重新加载应直接在首页加载）。
          // 仅初始导航生效（from 为初始路由，matched 为空）：SPA 内部导航（首页 → 内页 → 返回）不受影响，
          // keep-alive 缓存与 prevRoute 重拉机制保持原行为
          isInitialNav = !from || from.matched.length === 0;
          isClPath = to.path.indexOf('/customer-library/') === 0;
          isClIndex = /^\/customer-library\/index(\/|$)/.test(to.path);
          if (!(isInitialNav && isClPath && !isClIndex)) {
            _context.next = 8;
            break;
          }
          query = _objectSpread({}, to.query); // path 动态参数形式的 customerId（/customer-library/index/:customerId?）并入 query，
          // 首页 resolveFallbackCustomerId 统一从 query/params 解析
          if (to.params && to.params.customerId && !query.customerId) {
            query.customerId = String(to.params.customerId);
          }
          next({
            path: '/customer-library/index',
            query: query,
            replace: true
          });
          return _context.abrupt("return");
        case 8:
          next();
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

// 记录最近一次导航的来源路由：afterEach 在导航确认后、组件 activated 钩子之前触发，
// keep-alive 缓存页（客户资料库列表/公司详情/官文页等）在 activated 里读
// this.$router.prevRoute.path 区分「从子页（详情/宫格子页）返回」（保持缓存不重拉）
// 与「重新进入」（首页/上级页面再次进入，每次强制重拉）
router.afterEach(function (to, from) {
  router.prevRoute = from;
});
export default router;